import React from 'react';

export default function TemplateCategories() {
  return (
    <div>
      <h1 className="h4 mb-3">Template Categories</h1>
      <p className="text-muted">Manage template categories.</p>
    </div>
  );
}
